import { render, staticRenderFns } from "./Formations.vue?vue&type=template&id=13f12863&scoped=true"
import script from "./Formations.vue?vue&type=script&lang=js"
export * from "./Formations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f12863",
  null
  
)

export default component.exports